import request from '@utils/request'

export function fetchDepositList(params) {
  return request({
    url: '/admin/deposit',
    method: 'get',
    params,
  })
}

export function fetchDeposit(deposit_seq) {
  return request.get(`/admin/deposit/${deposit_seq || 0}`)
}

export function rejectDeposit(deposit_seq) {
  return request({
    url: `/admin/deposit/${deposit_seq}`,
    method: 'patch',
    data: {
      type: 'SET_REJECTED',
    },
  })
}

export function approveDeposit(deposit_seq) {
  return request({
    url: `/admin/deposit/${deposit_seq}`,
    method: 'patch',
    data: {
      type: 'SET_APPROVED',
    },
  })
}
